import { Component, Input } from '@angular/core';

@Component({
  selector: 'tvd-divider',
  template: `
    <div class="relative flex items-center">
      <div
        class="flex-grow border-t border-b-0 border-solid border-card-border"
      ></div>
      <span class="flex-shrink h-full text-neutral-600">
        <ng-content />
      </span>

      <div
        class="flex-grow border-t border-b-0 border-solid border-card-border"
      ></div>
    </div>
  `,
  styles: [
    `
      :host {
        span:not(:empty) {
          margin: 0 var(--tvd-spacing-2);
        }
      }
    `,
  ],
})
export class Divider {}
